import {types} from './types';

export const toggleShouldShowToolbarTo = (shouldShowToolbar) => {
    if (shouldShowToolbar) {
        return {
            type: types.SHOW_TOOLBAR
        }
    } else {
        return {
            type: types.HIDE_TOOLBAR
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/actions/toolbar-actions.js